import { Injectable } from "@angular/core";
import { AbstractControl, UntypedFormGroup } from "@angular/forms";

@Injectable({
    providedIn: 'root'
})
export class PasswordService{
    matchPassword(password: string, confirmPassword: string) {
        return (formGroup: UntypedFormGroup) => {
            const control = formGroup.controls[password];
            const matchingControl = formGroup.controls[confirmPassword];

            if (control.value !== matchingControl.value) {
                matchingControl.setErrors({ confirmPasswordMatch: true });
            } else {
                matchingControl.setErrors(null);
            }
        }
    }

    noRepeatPassword(passActual: string, newPassword: string){
        return (formGroup: UntypedFormGroup)=>{
            const actual = formGroup.controls[passActual];
            const newPass = formGroup.controls[newPassword];
            
            if(actual.value === newPass.value){
                newPass.setErrors({repeatPass:true});
            }else{
                newPass.setErrors(null);
            }
        }
    }
}